// extracted by mini-css-extract-plugin
export default {"reasonDropdown":"CancelContractModal_reasonDropdown__8IUvv","modalContainer":"CancelContractModal_modalContainer__ZbDsX"};